import { messages } from './Content.messages';

export const advantages = [messages.advantageNoCreditCard, messages.advantageUnlimitedUsers, messages.advantagesCancel];
